import "./MainNav.scss";

import MainNav from "./MainNav";

export default MainNav;
